export const workExperienceEntries = {
    job1: {
        company: "Positive Promotions",
        position: "Web Graphic Artist",
        dateRanges: "Feb. 2022 - ongoing",
        responsibilities: [
            "Communicate with other departments, marketing and photography, to develop graphics for: banners, product images, blog articles, landing pages, and gateway images.",
            "Build landing pages and blog articles, utilizing HTML, CSS and Bootstrap."
        ]
    },
    job2: {
        company: "Starbucks",
        position: "Barista Trainer",
        dateRanges: "Oct. 2017 - Jun. 2020",
        responsibilities: [
            "Instructed new hires on how to operate equipment and craft beverages.",
            "Assisted shift supervisor with managerial tasks."
        ]
    },
    job3: {
        company: "The University of the Arts",
        position: "Student Info Tech",
        dateRanges: "Oct. 2015 - May 2017",
        responsibilities: [
            "Assisted students and staff with technological issues, regarding: computers, projectors, printers, and networking."
        ]
    },
}

export const projectEntries = {
    project1: {
        company: "Joshua And The Promised Land: Reanimated Collab",
        position: "Animator",
        dateRanges: "Jan. 2021 - Feb. 2021",
        responsibilities: [
            "Contributed a 2D  animated scene for a community project, with a focus on rendering."
        ]
    },
    project2: {
        company: "Toy Story 2 Reanimated Collaboration",
        position: "Animator",
        dateRanges: "June 2021 - Sep.  2021",
        responsibilities: [
            "Contributed an animated scene with a focus on 2D/3D hybrid experimentation."
        ]
    },
    project3: {
        company: "The Spongebob Squarepants Movie: Rehydrated Collab",
        position: "Animator",
        dateRanges: "Sept 2020 - Jan 2021",
        responsibilities: [
            "Contributed a 2D animated scene with a focus on style experimentation."
        ]
    },
    project4: {
        company: "Scream Game Jam 2019",
        position: "2D & 3D Artist",
        dateRanges: "Oct. 2019 - Dec. 2019",
        responsibilities: [
            "Contributed 3D models with textures and developed UI for the game."
        ]
    },
}


export const generalExperiences = [
    "Utilized React.js, CSS,  and Bootstrap to create a portfolio website.",
    "Utilized Proxmox to set up virtual machines for; TrueNAS, Windows 10, and Debian.",
    "Created a WebRTC signaling server, utilizing websockets, for a multiplayer game."
]

export const skills = {
    "Operating Systems" : "Windows 10, Mac, Proxmox, Ubuntu, Debian",
    "Software" : "Photoshop, Godot, Blender, VSCode, Visual Studio, Unity, Sony Vega, Premiere",
    "Programming" : "Javascript, JSX, HTML/CSS, GDScript, C#"
}